import { render, staticRenderFns } from "./CreateMyBusinessLocation.vue?vue&type=template&id=573be03a&"
import script from "./CreateMyBusinessLocation.vue?vue&type=script&lang=js&"
export * from "./CreateMyBusinessLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports